import { useQuery } from "react-query"
import { useApiClient } from "../../api-client/api-client.hooks"
import { TApiSavedReport } from "../saved-reports-types"

interface Props {
  id: string
}

export function useSavedReportQuery(props: Props) {
  const {
    id,
  } = props

  const apiClient = useApiClient()

  const query = useQuery(
    ['saved-reports', id] as const,
    async () => {

      const response = await apiClient.get(`/saved_reports/${id}`)

      if (!response.ok) {
        throw response.errors
      }

      return response as {
        savedReport: TApiSavedReport
      }
    }
  )

  return query
}